export enum UserPages {
  PageRoleSelection = 'page.role-selection',
  PagePairedDevices = 'page.paired-devices',
}
